import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const SoundQueueContext = createContext(null);
/**
 * `{ queue, analyser }` 인스턴스 참조만 하위 트리에 배관(DI)하는 순수 Context.
 *
 * `value`는 호출부에서 `useMemo`(예: `useMemo(() => createSoundQueue(), [])`)로 한 번만 만들어 넘겨야 한다.
 * 참조가 바뀌지 않는 한, 재생 상태가 아무리 자주 바뀌어도 `useSoundQueueContext()`를 호출하는 것만으로는
 * 리렌더가 발생하지 않는다 — 실제 구독은 `useSoundQueueState`/`usePlayheadProgress` 등 별도 훅에서 한다.
 */
export function SoundQueueProvider({ value, children, }) {
    return _jsx(SoundQueueContext.Provider, { value: value, children: children });
}
/** 가장 가까운 `SoundQueueProvider`가 제공한 `{ queue, analyser }` 인스턴스를 꺼낸다. */
export function useSoundQueueContext() {
    const value = useContext(SoundQueueContext);
    if (!value) {
        throw new Error('useSoundQueueContext는 SoundQueueProvider 하위에서만 사용할 수 있습니다.');
    }
    return value;
}
//# sourceMappingURL=SoundQueueProvider.js.map